<template>
  <wg-modal
    :width="windowWidth > 992 ? '800px' : '90%'"
    :scroll="{ x: false, y: true }"
    @closeModal="$emit('close', false)"
  >
    <div class="wg-row auth-modal" slot="body" style="min-height:550px;">
      <div
        class="wg-row"
        style="margin-top:20px;flex-wrap:nowrap;align-items:center;justify-content:center;text-align:center;"
      >
        <div class="com-anm22-app-text-l">
          {{
            $anm22.strLang(
              lang,
              "A Spiagge.it account is required to complete the order",
              "È necessario un account Spiagge.it per completare l'ordine",
            )
          }}
        </div>
      </div>
      <transition-group name="slide" tag="div" class="wg-row slider">
        <!-- MAIN PAGE -->
        <div v-if="page === 'login'" :key="'login'">
          <div class="wg-row login">
            <form class="wg-row" @submit.prevent="login">
              <div v-if="errorString" id="anm22_wb_allarm" class="login-error">
                {{
                  $anm22.strLang(lang, "ATTENTION: ", "ATTENZIONE: ") +
                    errorString
                }}
              </div>
              <h1 class="form-title">
                {{ $anm22.strLang(lang, "Sign in", "Accedi") }}
              </h1>
              <div class="wg-row com-anm22-app-text-m">
                Email
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <input type="text" v-model="email" />
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row com-anm22-app-text-m">
                Password
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <input type="password" v-model="password" />
              </div>
              <div class="vertical-height-div" style="height:20px;"></div>
              <input
                type="submit"
                :value="$anm22.strLang(lang, 'Sign in', 'Accedi')"
              />
              <input type="hidden" name="log" value="ok" />
            </form>
            <div class="vertical-height-div" style="height:10px;"></div>
            <!-- <div >
              <a
                :href="'https://world.anm22.it/app/world/login-reset-password.php?cbue='+cbRoute"
                style="vertical-align:middle;color:#999;"
              >
                {{ $anm22.strLang(lang, 'Forgot password?', 'Password dimenticata?') }}
              </a>
            </div> -->
            <template v-if="false && !isApp">
              <div
                style="width:100%; border-bottom:1px solid #ccc;font-size:0px;height:0px;margin:15px auto 20px auto;"
              ></div>
              <div
                :style="
                  'background-image: url(' +
                    $anm22.icons.getWorldIcon('facebookWhite') +
                    ');'
                "
                class="fb-login-btn"
                @click="fbLoginClick"
              >
                <div class="label">
                  {{
                    $anm22.strLang(
                      lang,
                      "Continue with Facebook",
                      "Continua con Facebook",
                    )
                  }}
                </div>
              </div>
            </template>
            <div
              style="width:100%; border-bottom:1px solid #ccc; font-size: 0px; height:0px; margin: 20px auto;"
            ></div>
            <input
              type="button"
              :value="$anm22.strLang(lang, 'Sign up', 'Registrati')"
              @click="beginRegistration"
            />
            <div class="vertical-height-div" style="height:20px;"></div>
          </div>
        </div>
        <!-- REGISTRATION PAGE -->
        <div v-if="page === 'signup'" :key="'signup'">
          <div class="wg-row signup">
            <form class="wg-row">
              <div v-if="errorString" id="anm22_wb_allarm" class="login-error">
                {{
                  $anm22.strLang(lang, "ATTENTION: ", "ATTENZIONE: ") +
                    errorString
                }}
              </div>
              <div
                class="wg-row"
                style="flex-wrap:nowrap;align-items:center;position:relative;"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('back')"
                  class="com-anm22-app-img-fixed-height-l"
                  style="position:absolute;left:0;"
                  @click="page = 'login'"
                />
                <h1 class="form-title">
                  {{ $anm22.strLang(lang, "Sign up", "Registrati") }}
                </h1>
              </div>
              <div class="wg-row com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Name", "Nome") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <input type="text" v-model="name" />
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Surname", "Cognome") }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <input type="text" v-model="surname" />
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Phone", "Telefono") }}
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
              <div
                class="wg-row com-anm22-app-text-m"
                style="flex-wrap:nowrap;"
              >
                <select
                  class="com-anm22-app-select"
                  style="flex:1;"
                  v-model="phone.areaCode"
                >
                  <option value selected disabled hidden>{{
                    $anm22.strLang(lang, "Select", "Seleziona")
                  }}</option>
                  <option
                    v-for="(obj,
                    key,
                    index) in $anm22.tableClasses.areaCode().getAll()"
                    :key="'areaCode-' + index"
                    :value="key"
                    >{{ obj[lang] }}</option
                  >
                </select>
                <input style="flex:2;" type="text" v-model="phone.number" />
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row com-anm22-app-text-m">
                Email
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <input type="text" v-model="email" />
              </div>
              <div class="vertical-height-div" style="height:20px;"></div>
              <div class="wg-row com-anm22-app-text-m">
                Password
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <input type="password" v-model="password" />
              </div>
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row com-anm22-app-text-m">
                {{
                  $anm22.strLang(lang, "Confirm password", "Conferma password")
                }}
              </div>
              <div class="vertical-height-div" style="height:5px;"></div>
              <div class="wg-row">
                <input type="password" v-model="passConfirm" />
              </div>
            </form>
            <div class="vertical-height-div" style="height:20px;"></div>
            <input
              type="button"
              :value="$anm22.strLang(lang, 'Sign up', 'Registrati')"
              @click="signUp"
            />
            <input type="hidden" name="reg" value="ok" />
            <div class="vertical-height-div" style="height:20px;"></div>
          </div>
        </div>
        <!-- TERMS PAGE -->
        <div v-if="page === 'terms'" :key="'terms'" class="wg-row">
          <div class="display-flex privacy">
            <h1>
              {{ $anm22.strLang(lang, "Privacy & Terms", "Privacy & Termini") }}
            </h1>
            <h2>
              {{
                $anm22.strLang(
                  lang,
                  "Last update: ",
                  "Ultimo aggiornamento: ",
                ) + termsLastUpdate
              }}
            </h2>
            <div class="terms" v-html="terms"></div>
            <input
              type="button"
              :value="$anm22.strLang(lang, 'Accept', 'Accetta')"
              @click="acceptTerms"
            />
            <div class="vertical-height-div" style="height:20px;"></div>
          </div>
        </div>
      </transition-group>
    </div>
  </wg-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    lang: {
      type: String,
      default: "it",
    },
    // show: {
    //   type: Boolean,
    //   default: false
    // },
    // Precompile inputs
    order: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading: false,
      timezone: this.$moment.tz.guess(),
      page: "login",
      pages: ["login", "terms", "signup"],
      /* INPUTS */
      email: "",
      password: "",
      name: "",
      surname: "",
      passwordConfirm: "",
      phone: {
        areaCode: "+39",
        number: this.order ? this.order.deliveryData.phone : "",
      },
      fbId: "",
      /* LOGIN */
      errorString: "",
      fbLoginStatus: null,
      /* SIGNUP */
      passConfirm: "",
      /* TERMS */
      terms: "",
      termsLastUpdate: "",
      showTerms: false,
    };
  },
  computed: {
    ...mapState({
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
    }),
    isApp() {
      return this.$anm22.getCookie("anm22_world_app_mode") !== "";
    },
  },
  methods: {
    manageErrors(code) {
      switch (code) {
        case 1:
          this.errorString = this.$anm22.strLang(
            this.lang,
            "Wrong email or password! Please, try again.",
            "Indirizzo e-mail o password errati! Provare nuovamente.",
          );
          break;
        case 2:
          this.errorString = this.$anm22.strLang(
            this.lang,
            "Empty password! Please, try again.",
            "Nessuna password inserita! Provare nuovamente.",
          );
          break;
        case 3:
          this.errorString = this.$anm22.strLang(
            this.lang,
            "Wrong email or password! Please, try again.",
            "Indirizzo e-mail o password errati! Provare nuovamente.",
          );
          break;
        case 4:
          this.errorString = this.$anm22.strLang(
            this.lang,
            "You don't have the right authorization to access to this app section.",
            "Autorizzazione negata per l'accesso a questa sezione dell'applicazione.",
          );
          break;
        default:
          this.errorString = this.$anm22.strLang(
            this.lang,
            "An error has occured",
            "C'è stato un errore",
          );
      }
    },
    async login() {
      this.errorString = "";
      try {
        const loginResponse = await this.$http.post("auth/login", {
          email: this.email,
          password: this.$anm22.MD5(this.password),
        });
        if (!loginResponse.data.error) {
          if (loginResponse.data.validSignature) {
            this.auth();
          } else {
            this.terms = loginResponse.data.terms;
            this.termsLastUpdate = this.$moment
              .unix(loginResponse.data.lastUpdate)
              .format("LL");
            this.page = "terms";
          }
        } else {
          this.manageErrors(loginResponse.data.error);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async acceptTerms() {
      try {
        const response = await this.$http.post("auth/terms");
        if (!response.data.error) {
          this.auth();
        }
      } catch (e) {
        console.log(e);
      }
    },
    async auth() {
      const authResponse = await this.$http.get("auth/");
      if (!authResponse.data.error) {
        await Promise.all([
          this.$vlf("auth").setItem("user", authResponse.data.user),
          //Save locally licenses (employment)
          this.$store.dispatch("foodLicenses/update", {
            vlf: this.$vlf("foodLicenses"),
            objs: authResponse.data.licenses,
          }),
          this.$store.dispatch("foodEmployments/update", {
            vlf: this.$vlf("foodEmployments"),
            objs: authResponse.data.employments,
          }),
          this.$store.dispatch("works/update", {
            vlf: this.$vlf("works"),
            objs: authResponse.data.works,
          }),
          this.$store.dispatch("foodAcs/update", {
            vlf: this.$vlf("foodAcs"),
            objs: authResponse.data.foodAcs,
          }),
        ]);
        await this.$store.dispatch("auth/updateUserInfo", {
          data: authResponse.data.user,
          app: this,
        });
        // Close popup and proceed with checkout
        this.$emit("close", true);
      } else {
      }
    },
    // FACEBOOK - ONLY IF NOT NATIVE APP
    fbLoginClick() {
      if (this.fbLoginStatus !== "connected") {
        window.FB.login(
          (response) => {
            // handle the response
            if (response.status === "connected") {
              this.fbLogin();
            } else {
              //Errore da stampare
            }
          },
          { scope: "email" },
        );
      } else {
        this.fbLogin();
      }
    },
    fbLogin() {
      window.FB.api(
        "/me?fields=id,name,email,first_name,last_name",
        async (fbResponse) => {
          try {
            const loginResponse = await this.$http.post(
              "auth/fbLogin",
              fbResponse,
            );
            if (!loginResponse.data.error) {
              // this.lang = loginResponse.data.lang;
              if (loginResponse.data.validSignature) {
                // this.redirect();
                this.auth();
              } else {
                this.terms = loginResponse.data.terms;
                this.termsLastUpdate = this.$moment
                  .unix(loginResponse.data.lastUpdate)
                  .format("LL");
                this.showTerms = true;
              }
            } else {
              if (loginResponse.data.error == 1) {
                this.fbId = fbResponse["id"];
                this.name = fbResponse["first_name"];
                this.surname = fbResponse["last_name"];
                this.email = fbResponse["email"];
                this.beginRegistration();
              }
            }
          } catch (e) {}
        },
      );
    },
    // SIGNUP
    beginRegistration() {
      this.page = "signup";
    },
    async signUp() {
      // Validation
      if (
        !/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(
          this.email,
        )
      ) {
        console.log("wrong email");
        return;
      }
      if (
        !this.name ||
        this.name === "" ||
        !this.surname ||
        this.surname === ""
      ) {
        console.log("empty name / surname");
        return;
      }
      if (!this.phone.number || this.phone.number === "") {
        console.log("empty phone");
        return;
      }
      if (!this.password || this.password === "") {
        console.log("empty pass");
        return;
      }
      if (!this.passConfirm || this.passConfirm !== this.password) {
        console.log("pass not corresponding");
        return;
      }
      // Save
      const response = await this.$http.post("auth/sign-up", {
        name: this.name,
        surname: this.surname,
        phoneAreaCode: this.phone.areaCode,
        phoneNumber: this.phone.number,
        email: this.email,
        password: this.$anm22.MD5(this.password),
        timezone: this.timezone,
      });
      if (!response.data.error) {
        if (response.data.validSignature) {
          // this.redirect();
          this.auth();
        } else {
          this.terms = response.data.terms;
          this.termsLastUpdate = this.$moment
            .unix(response.data.lastUpdate)
            .format("LL");
          this.page = "terms";
        }
      } else {
        this.manageErrors(response.data.error);
      }
    },
  },
  created() {
    /* Google analytics */
    (function(i, s, o, g, r, a, m) {
      i["GoogleAnalyticsObject"] = r;
      (i[r] =
        i[r] ||
        function() {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      "script",
      "https://www.google-analytics.com/analytics.js",
      "ga",
    );
    window.ga("create", "UA-40652727-1", "auto");
    window.ga("send", "pageview");

    /* FB Login - solo se non all'interno di un app Android o iOS */
    if (!this.isApp) {
      window.fbAsyncInit = function() {
        window.FB.init({
          appId: "746342188714963",
          cookie: true,
          xfbml: true,
          version: "v2.12",
        });
        //This function should be here, inside window.fbAsyncInit
        window.FB.getLoginStatus(function(response) {
          this.fbLoginStatus = response.status;
        });
      };

      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    }

    // Pre compilo dati
    if (this.order.customerName) {
      this.name = this.order.customerName;
    }
    if (this.order.customerSurname) {
      this.surname = this.order.customerSurname;
    }
    if (this.order.customerEmail) {
      this.email = this.order.customerEmail;
    }
    if (this.order.customerPhone) {
      this.phoneNumber = this.order.customerPhone;
    }
  },
};
</script>

<style lang="scss" scoped>
// .page-body {
//   width: 100%;
//   position: relative;
//   overflow: hidden;
//   min-height: 555px;
//   background-color: #f5f5f5;
//   background-size: cover;
//   background-position: center;
//   padding-bottom: 40px;
//   box-sizing: border-box;
// }
// .login-container {
//   padding: 20px;
//   margin: 0 auto;
//   text-align: center;
//   width: 100%;
//   max-width: 400px;
//   background-color: #fff;
//   box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
//   border-radius: 2px;
//   margin-top: 20px;
// }

.slider {
  // overflow-x: hidden;
  justify-content: center;
  & > div {
    width: 100%;
    position: absolute;
    top: 70px;
    left: 0;
    display: flex;
    justify-content: center;
    & > div {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      justify-content: center;
    }
  }
}
.login {
  max-width: 400px;
}

.login-error {
  background-color: #f99;
  padding: 12px;
  border-radius: 6px;
}

// Transition between pages
.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.form-title {
  font-weight: bold;
  font-size: 24px;
  padding: 10px 0;
  margin: 10px 0;
  text-align: center;
}
form {
  max-width: 300px;
  min-width: 200px;
  margin: 0 auto;
  padding: 0;
  border: 0;
}

.privacy {
  h1 {
    width: auto;
    font-weight: 500;
    font-size: 20px;
    margin: 0;
    padding: 10px 0;
    color: #999;
  }
  h2 {
    width: auto;
    font-weight: normal;
    font-size: 14px;
    margin: 0;
    padding: 0 0 10px 0;
    color: #000;
  }
  .terms {
    height: 50vh;
    overflow: auto;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    margin-bottom: 20px;
  }
}

.fb-login-btn {
  color: #fff;
  background-color: #3975ea;
  border-radius: 8px;
  padding: 14px 0;
  margin: 0 auto;
  display: inline-block;
  background-position: 8px center;
  background-repeat: no-repeat;
  background-size: 30px;
  cursor: pointer;

  .label {
    color: rgb(255, 255, 255);
    padding: 0px 16px 0px 46px;
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
